__turbopack_context__.v({
  "assetId": "_00cs6a_assetId",
  "body": "_00cs6a_body",
  "closeButton": "_00cs6a_closeButton",
  "error": "_00cs6a_error",
  "header": "_00cs6a_header",
  "panel": "_00cs6a_panel",
  "progress": "_00cs6a_progress",
  "progressFill": "_00cs6a_progressFill",
  "progressPercent": "_00cs6a_progressPercent",
  "progressTrack": "_00cs6a_progressTrack",
  "skeleton": "_00cs6a_skeleton",
  "skeletonCard": "_00cs6a_skeletonCard",
  "skeletonCircle": "_00cs6a_skeletonCircle",
  "skeletonRow": "_00cs6a_skeletonRow",
  "statusBadge": "_00cs6a_statusBadge",
  "statusDot": "_00cs6a_statusDot",
  "statusRow": "_00cs6a_statusRow",
  "title": "_00cs6a_title",
  "titleRow": "_00cs6a_titleRow",
});
